import React, { forwardRef } from "react";

const ControllerInput = forwardRef(({ label, type = "text", error, ...props }, ref) => {
  return (
    <div className="form-group mb-3">
      {label && <label className="form-label fw-semibold mb-1">{label}</label>}
      <input
        type={type}
        className={`form-control ${error ? "is-invalid" : ""}`}
        ref={ref}
        {...props}
      />
      {error && <div className="text-danger mt-1">{error}</div>}
    </div>
  );
});

export default ControllerInput;
